import { useCatalogoByFilters } from "api/Catalogo.hook"
import { useCategoriasItems } from "api/Categoria.hook"
import Button from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import CamposPersonalizadoBoard from "common/components/FormikFields/CamposPersonalizadosBoard"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import TabNav from "common/components/TabNav"
import { CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE } from "common/utils/constants"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants"
import ImagePreview from "features/Inventario/components/ImagePreview"
import { TIPO_ARTICULOS_OPTIONS } from "features/Inventario/constants/constants"
import { Dropdown } from "primereact/dropdown"
import { InputSwitch } from "primereact/inputswitch"
import { MultiSelect } from "primereact/multiselect"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const TABS = (t: $TSMigrationFixMe) => [
  {
    header: `${t("inventario.articulos.modal.newArticle.headerBasicData")}`,
    id: 0,
  },
  {
    header: `${t("inventario.articulos.modal.newArticle.headerImg")}`,
    id: 1,
  },
  {
    header: `${t("inventario.articulos.modal.newArticle.headerPers")}`,
    id: 2,
  },
]

const ArticuloForm = ({
  handleSubmit,
  onHide,
  setFieldValue,
  values,
  isSubmitting,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [tabSelected, setTabSelected] = useState(0)
  const { categoriasItems, categoriasItemsLoading } = useCategoriasItems()
  const { catalogoByFilters, catalogoByFiltersLoading } = useCatalogoByFilters()

  const setImage = (image: $TSMigrationFixMe) => {
    setFieldValue("FileAsFormFile", image)
    setFieldValue("imagenBase64", null)
    setFieldValue("ficheroId", null)
  }

  const deleteImage = () => {
    setImage(null)
  }

  const handleOnDropImage = (files: $TSMigrationFixMe) => {
    setImage(files?.[0])
  }

  const handleOnChangeCategorias = (e: $TSMigrationFixMe) => {
    setFieldValue("categoriasId", e.value)
  }

  const handleOnChangeCatalogos = (e: $TSMigrationFixMe) => {
    setFieldValue("catalogosId", e.value)
  }

  const handleOnChangeTipoArticulo = (e: $TSMigrationFixMe) => {
    setFieldValue("tipoArticulo", e.target.value)
  }

  return (
    <div className='p-2'>
      <TabNav
        tabs={TABS(t)}
        active={tabSelected}
        setActive={setTabSelected}
      />

      <form onSubmit={handleSubmit}>
        {tabSelected === 0 && (
          <div className='mt-3 modal__min__height'>
            <div className='p-fluid p-grid'>
              <div className='p-field col'>
                <label htmlFor='concepto'>
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titleConcept"
                  )}
                </label>

                <FormikInputText
                  id='concepto'
                  name='concepto'
                />
              </div>
            </div>

            <div className='p-fluid p-grid'>
              <div className='col-md-12 col-lg-4'>
                <label htmlFor='precioVenta'>
                  {" "}
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titlePrice"
                  )}{" "}
                  (€)
                </label>

                <FormikInputNumber
                  min={0}
                  mode='currency'
                  currency={DEFAULT_CURRENCY_ABREVIATURE}
                  minFractionDigits={2}
                  id='precioVenta'
                  name='precioVenta'
                />
              </div>

              <div className='col-md-12 col-lg-4'>
                <label htmlFor='tipoArticulo'>
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titleType"
                  )}
                </label>

                <Dropdown
                  value={values.tipoArticulo}
                  options={TIPO_ARTICULOS_OPTIONS(t)}
                  onChange={handleOnChangeTipoArticulo}
                  panelClassName='!tw-z-[2302]'
                />
              </div>

              <div className='col-md-12 col-lg-4'>
                <label htmlFor='numeroReferencia'>
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titleRefernce"
                  )}
                </label>

                <FormikInputText
                  id='numeroReferencia'
                  name='numeroReferencia'
                />
              </div>
            </div>

            <div className='tw-mt-2 tw-grid tw-grid-cols-2 tw-gap-4'>
              <div className='tw-flex tw-flex-col'>
                <label htmlFor='categorias-articulo'>
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titleCategory"
                  )}
                </label>

                <MultiSelect
                  filter
                  showClear
                  disabled={categoriasItemsLoading}
                  selectedItemsLabel={`${values.categoriasId?.length} categorías seleccionadas`}
                  id='categorias-articulo'
                  value={categoriasItems ? values.categoriasId : undefined}
                  optionLabel='nombre'
                  optionValue='id'
                  options={categoriasItems ?? []}
                  onChange={handleOnChangeCategorias}
                  placeholder={`${
                    categoriasItemsLoading
                      ? t(
                          "inventario.articulos.modal.newArticle.basicData.loading"
                        )
                      : t(
                          "inventario.articulos.modal.newArticle.basicData.placeholderCategory"
                        )
                  }`}
                  emptyFilterMessage={`${t(
                    "inventario.articulos.modal.newArticle.basicData.emptyMsgCategory"
                  )}`}
                  panelClassName='!tw-z-[2302]'
                />
              </div>

              <div className='tw-flex tw-flex-col'>
                <label htmlFor='catalogos-articulo'>
                  {t(
                    "inventario.articulos.modal.newArticle.basicData.titleCatalog"
                  )}
                </label>

                <MultiSelect
                  filter
                  id='catalogos-articulo'
                  optionLabel='nombre'
                  optionValue='id'
                  disabled={catalogoByFiltersLoading}
                  value={catalogoByFilters ? values.catalogosId : undefined}
                  selectedItemsLabel={`${values.catalogosId?.length} categorías seleccionadas`}
                  options={catalogoByFilters ?? []}
                  onChange={handleOnChangeCatalogos}
                  placeholder={`${t(
                    catalogoByFiltersLoading
                      ? "inventario.articulos.modal.newArticle.basicData.loading"
                      : "inventario.articulos.modal.newArticle.basicData.planceholderCatalog"
                  )}`}
                  emptyFilterMessage={`${t(
                    "inventario.articulos.modal.newArticle.basicData.emptyMsgCatalog"
                  )}`}
                  panelClassName='!tw-z-[2302]'
                />
              </div>
            </div>
          </div>
        )}

        {tabSelected === 1 && (
          <div className='mt-3 row p-fluid modal__min__height'>
            <div className='col-md-12'>
              <ImagePreview
                image={values.FileAsFormFile}
                imagenBase64={values.imagenBase64}
                imagenMediaType={values.imagenMediaType}
                setImage={setImage}
                deleteImage={deleteImage}
              />

              {!values.FileAsFormFile && !values.imagenBase64 && (
                <Dropzone
                  maxFiles={1}
                  accept='image/*'
                  acceptLabel='image/*'
                  onDrop={handleOnDropImage}
                  hideAcceptedFilesMsg
                  butonLabel={t("inventario.articulos.modal.searchImageButton")}
                />
              )}
            </div>
          </div>
        )}

        {tabSelected === 2 && (
          <CamposPersonalizadoBoard
            className='pt-4'
            endpointSlice={CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE.artilculo}
            camposPersonalizados={values.camposPersonalizados}
          />
        )}

        <div className='mt-4 col'>
          <div className='tw-flex tw-flex-row tw-justify-between tw-items-center'>
            <div className='tw-flex tw-flex-row tw-items-center'>
              <InputSwitch
                checked={values.esDeCompra}
                onChange={() => setFieldValue("esDeCompra", !values.esDeCompra)}
                className='tw-cursor-pointer tw-mr-3'
              />
              <span>{t("inventario.articulos.modal.isCompra")}</span>
            </div>
            <div className='tw-flex tw-flex-row tw-items-center'>
              <span
                className='tw-mr-4 tw-flex tw-items-center tw-text-center tw-h-12 tw-cursor-pointer tw-px-5'
                onClick={onHide}
              >
                {t("inventario.articulos.modal.cancelButton")}
              </span>

              <Button
                type='submit'
                loading={isSubmitting}
                className='!tw-bg-secondary tw-cursor-pointer hover:!tw-bg-secondary-over !tw-border-none !tw-h-12'
              >
                {values.isEdit
                  ? t("inventario.articulos.modal.headerEdit")
                  : t("inventario.articulos.modal.createArticle")}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ArticuloForm
